<template>
  <div>
    <div class="app-toolbar1">
      <label>登录账号</label>
      <el-input size="small" placeholder="请输入登录账号" v-model="query.username" clearable style="width:240px;margin-right:10px;"></el-input>
      <label>联系电话</label>
      <el-input size="small" placeholder="请输入联系电话" v-model="query.mobile" clearable style="width:240px"></el-input>
      <el-button size="small" @click="toAdd" type="primary">添加</el-button>
      <el-button size="small" @click="load(1)">查询</el-button>
    </div>
    <el-table :data="admins" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="username" label="登录账号"></el-table-column>
      <el-table-column prop="mobile" label="联系电话"></el-table-column>
      <el-table-column prop="roleName" label="角色"></el-table-column>
      <el-table-column prop="status" label="状态" :formatter="statusFormatter"></el-table-column>
      <el-table-column fixed="right" label="操作" width="218">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
          <el-button @click="changeStatus(scope.row)" type="danger" size="small" v-if="scope.row.status === 'ENABLE'">禁用</el-button>
          <el-button @click="changeStatus(scope.row)" type="danger" size="small" v-if="scope.row.status === 'DISABLE'">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入登录账号" :maxlength="40" :readonly="!!currentUpdateAdminId"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" placeholder="请输入登录密码" :maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号码" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId" placeholder="请选择角色" style="width:100%">
            <el-option v-for="role in roles" :key="role.roleId" :label="role.name" :value="role.roleId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { calcPage } from '../../util'

export default {
  name: 'admin-manage',
  data () {
    return {
      loading: false,
      admins: [],
      roles: [],
      query: {
        page: 1,
        limit: 10,
        total: 0,
        username: '',
        mobile: ''
      },
      showForm: false,
      formTitle: '添加账户',
      form: {
        username: '',
        password: '',
        mobile: '',
        roleId: null
      },
      formRule: {
        username: [
          { required: true, message: '请输入登录账户', trigger: 'blur' },
          { min: 6, message: '长度不能小于6位', trigger: 'blur' }
        ],
        mobile: [{ min: 11, max: 11, message: '长度必须是11位', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        password: [{
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!this.currentUpdateAdminId && !value) {
              callback(new Error('请输入登录密码'))
            } else {
              callback()
            }
          }
        }]
      },
      currentUpdateAdminId: 0
    }
  },
  created () {
    this.load(1)
  },
  methods: {
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgAdmins?page=${page}&limit=${this.query.limit}&username=${this.query.username}&mobile=${this.query.mobile}`
      }).then((res) => {
        let pageData = res.data.data
        this.admins = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      })
    },
    loadRole () {
      this.$http.request({
        method: 'get',
        url: '/api/cgRoles'
      }).then((res) => {
        this.roles = res.data.data
      })
    },
    toAdd () {
      this.formTitle = '添加账户'
      this.currentUpdateAdminId = 0
      this.form = {username: '', password: '', mobile: '', roleId: null}
      this.showForm = true
      this.loadRole()
    },
    toUpdate (row) {
      this.formTitle = '修改账户'
      this.currentUpdateAdminId = row.adminId
      this.form = {username: row.username, password: '', mobile: row.mobile, roleId: row.roleId}
      this.showForm = true
      this.loadRole()
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该管理员吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let adminId = this.currentUpdateAdminId
          this.$http.request({
            method: adminId === 0 ? 'post' : 'put',
            url: adminId === 0 ? '/api/cgAdmins' : `/api/cgAdmins/${adminId}`,
            data: JSON.stringify({
              username: this.form.username,
              password: this.form.password ? md5(this.form.password) : '',
              mobile: this.form.mobile,
              roleId: this.form.roleId
            })
          }).then(() => {
            this.showForm = false
            this.load(this.query.page)
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgAdmins/${data.adminId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    },
    changeStatus (row) {
      this.$http.request({
        method: 'put',
        url: `/api/cgAdmins/${row.adminId}/status`,
        data: JSON.stringify({
          status: row.status === 'ENABLE' ? 'DISABLE' : 'ENABLE'
        })
      }).then(() => {
        this.load(this.query.page)
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    statusFormatter (row, column, cellValue) {
      return cellValue === 'ENABLE' ? '启用' : '禁用'
    }
  }
}
</script>
